import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import Popup from 'reactjs-popup';
import ScreenHeader from '../../components/ScreenHeader.js';

import useSWR from 'swr'
import { localAxios } from "../../api.js";

import 'reactjs-popup/dist/index.css';

import AddVisitorNew from "./AddVisitorNew.jsx";
import VisitorList from "./VisitorList.jsx";
import VisitorContext from "./VisitorContext.jsx";

function RegisterVisitor() {

  const { data, error, isLoading, mutate } = useSWR('/api/me', localAxios)
  const {
    visitLocationId, visitLocation,
    visitDate,
    visitors,
    clearAll,
  } = useContext(VisitorContext);

  const navigate = useNavigate();

  const [isConfirming, setIsConfirming] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [guardianError, setGuardianError] = useState(false);

  useEffect(() => {
    if (error) {
      // handle the error
    }
  }, [error])

  useEffect(() => {
    if (guardianError) {
      const allGuarded = visitors.every(
        v => !v.visitor_is_minor || v.user_is_guardian || (v.guardian_id && !v.guardian_missing)
      );
      if (allGuarded) setGuardianError(false);
    }
  }, [visitors]);

  useEffect(() => {
    if (visitors.length > 0) {
      localAxios.post('/api/workflow-state', { step: 'register-visitor', site_id: visitLocationId ?? null })
        .catch((err) => console.log('Error saving workflow state:', err));
    }
  }, [visitors.length, visitLocationId]);

  const handleSubmitClick = () => {
    if (!visitLocationId) {
      alert('Please select a location before submitting.');
      return;
    }
    if (visitors.length === 0) {
      alert('Please add at least one person before submitting.');
      return;
    }
    const hasUnguardedMinor = visitors.some(
      v => v.visitor_is_minor && !v.user_is_guardian && (!v.guardian_id || v.guardian_missing)
    );
    if (hasUnguardedMinor) {
      setGuardianError(true);
      return;
    }
    setGuardianError(false);
    setIsConfirming(true);
  };

  const doSubmit = async () => {
    setIsSubmitting(true);
    try {
      await localAxios.post('/api/users/invite', {
        siteID: visitLocationId.toString(),
        visitDate: visitDate,
        people: JSON.stringify(visitors),
      });
      navigate('/visit-submitted', {
        state: { visitLocation, visitDate, visitors: [...visitors] },
      });
      clearAll();
    } catch (err) {
      console.log(err);
      alert('Something went wrong. Please try again.');
      setIsSubmitting(false);
    }
  };

  return (
    <div className="app-wide__container">
      <ScreenHeader message={"Plan a Site Visit"} />
      <div className="app-wide__add-new">
        <AddVisitorNew />
      </div>
      <div className="app-wide__main register-visitor__main">
        <VisitorList />
      </div>
      <div className="app-wide__footer">
        {guardianError && (
          <p className="register-visitor__guardian-error">
            One or more minors need a guardian assigned before submitting.
          </p>
        )}
        <div className="formButtons">
          <button
            className="button save"
            onClick={handleSubmitClick}
            disabled={isSubmitting}
          >
            {isSubmitting ? <span className="spinner" /> : 'Submit'}
          </button>
          <button className="button cancel" onClick={() => navigate('/')}>Cancel</button>
        </div>
      </div>

      <Popup
        open={isConfirming}
        modal
        onClose={() => setIsConfirming(false)}
        overlayStyle={{ alignItems: 'flex-start', paddingTop: '16px' }}
      >
        {close => (
          <div className="confirm-popup">
            <div className="confirm-popup__header">Confirm Submission</div>
            <p className="confirm-popup__body">
              Submit the planned visit to <strong>{visitLocation}</strong> on{' '}
              <strong>
                {new Date(visitDate + 'T00:00:00').toLocaleDateString('en-US', {
                  weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'
                })}
              </strong>? The visit plan includes <strong>{visitors.length}</strong> {visitors.length === 1 ? 'person' : 'people'}.
            </p>
            <div className="formButtons">
              <button className="button save" onClick={() => { close(); doSubmit(); }}>
                Yes, Submit
              </button>
              <button className="button cancel" onClick={close}>Cancel</button>
            </div>
          </div>
        )}
      </Popup>
    </div>
  );
}

export default RegisterVisitor;
